var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NotFound"},[_vm._v("\n    404 Not Found\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }